// Директива запускает метод когда пользователь скроллит в самый низ блока
const scrollEnd = {
  inserted: function (el, binding) {
    const onScrollCallback = binding.value;

    el.addEventListener('scroll', () => {
      if (el.offsetHeight + el.scrollTop >= el.scrollHeight) {
        el.removeEventListener('scroll', onScrollCallback);
        return onScrollCallback();
      }
    });
  }
};

export default scrollEnd;
